import React, { useState, useEffect } from 'react';
import { withStyles, Stepper, StepLabel, Step, Paper, Dialog, CircularProgress } from '@material-ui/core';
import moment from "moment";
import StorageForm from './StorageForm'
import { connect } from 'react-redux';
import * as Yup from 'yup';
import History from '../../../History';
import * as actions from './store/storageActions';
import { BackButton, parseURL, hasPermission } from '../../sc-utilities';
import AppLogoLoading from '../../sc-logo';
import { fetchSecurazeSolutions } from '../../sc-admin/SecurazeSolution/store/securazeSolutionActions';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const StorageEdit = props => {
    const { activeCustomer, onFetchUsers, onFetchErasureMethods, translations, storage, creating, classes, onEditStorage, permissions, onFetchStorage, onFetchSecurazeSolutions } = props;
    const [activeStep, setActiveStep] = useState(0);
    const steps = [translations['basic_info'] || 'Basic info', translations['advanced_info'] || 'Advanced info', translations['wipe_info'] || 'Wipe info', translations['verification_info'] || 'Verification info'];
    const [data, setData] = useState({ user: [], data: true, methods: [], securazeSolutions: [] });

    let searchParams = parseURL(window.location.search);

    const submitHandler = async data => {
        data['ComponentID'] = storage.ComponentID;
        data['WipeProgress'] = data.WipeProgress && data.WipeProgress > 100 ? 100 : data.WipeProgress;
        data['VerificationProgress'] = data.VerificationProgress && data.VerificationProgress > 100 ? 100 : data.VerificationProgress;
        data['ComponentType'] = 'storage';
        data['ProductID'] = searchParams.productID;
        await onEditStorage({ ...data, ActiveCustomerID: activeCustomer });
        setActiveStep(0);
        History.goBack()
    }

    useEffect(() => {
        const fetchData = async () => {
            await onFetchStorage({ ComponentID: searchParams.ComponentID, ActiveCustomerID: activeCustomer, ProductID: searchParams.productID });
            let user = await onFetchUsers({ ActiveCustomerID: activeCustomer });
            let methods = await onFetchErasureMethods({ ActiveCustomerID: activeCustomer })
            const solutions = await onFetchSecurazeSolutions({ ActiveCustomerID: activeCustomer });
            let securazeSolutionsSelectOptions = [];
            if (solutions) {
                securazeSolutionsSelectOptions = solutions.map((solution) => { return {value: solution.Key, displayValue: solution.LongName} });
            }
            setData({ user: user, data: false, methods: methods, securazeSolutions: securazeSolutionsSelectOptions });
        }
        fetchData();
        return () => {
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const cancelHandler = () => {
        setActiveStep(0);
        History.goBack();
    }

    const handleBack = () => {
        setActiveStep(activeStep - 1);
    };

    const handleNext = () => {
        setActiveStep(activeStep + 1);
    };

    let initialValues = {
        Type: storage && storage.StorageComponents && storage.StorageComponents.length > 0 && storage.StorageComponents[0].Type ? storage.StorageComponents[0].Type : '',
        Transport: storage && storage.StorageComponents && storage.StorageComponents.length > 0 && storage.StorageComponents[0].Transport ? storage.StorageComponents[0].Transport : '',
        ComponentType: 'storage',
        Size: storage && storage.StorageComponents && storage.StorageComponents.length > 0 && storage.StorageComponents[0].Size ? storage.StorageComponents[0].Size || 0 : 0,
        Vendor: storage && storage.Vendor ? storage.Vendor : '',
        ComponentModel: storage && storage.ComponentModel ? storage.ComponentModel : '',
        SerialNumber: storage && storage.SerialNumber ? storage.SerialNumber : '',
        LogicalName: storage && storage.StorageComponents && storage.StorageComponents.length > 0 && storage.StorageComponents[0].LogicalName ? storage.StorageComponents[0].LogicalName : '',
        Description: storage && storage.Description ? storage.Description : '',
        Sectors: storage && storage.StorageComponents && storage.StorageComponents.length > 0 && storage.StorageComponents[0].Sectors ? storage.StorageComponents[0].Sectors : 0,
        ReallocatedSectors: storage && storage.StorageComponents && storage.StorageComponents.length > 0 && storage.StorageComponents[0].ReallocatedSectors ? storage.StorageComponents[0].ReallocatedSectors : 0,
        HPA: storage && storage.StorageComponents && storage.StorageComponents.length > 0 && storage.StorageComponents[0].HPA ? storage.StorageComponents[0].HPA : '',
        DCO: storage && storage.StorageComponents && storage.StorageComponents.length > 0 && storage.StorageComponents[0].DCO ? storage.StorageComponents[0].DCO : '',
        OverallState: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].OverallState || 0 : 0,
        PowerOnHours: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].PowerOnHours || 0 : 0,
        ProgramFails: storage && storage.StorageComponents && storage.StorageComponents.length > 0 && storage.StorageComponents[0].ProgramFails !== null ? storage.StorageComponents[0].ProgramFails || 0 : 0,
        UncorrectableErrors: storage && storage.StorageComponents && storage.StorageComponents.length > 0 && storage.StorageComponents[0].UncorrectableErrors !== null ? storage.StorageComponents[0].UncorrectableErrors || 0 : 0,
        PendingSectors: storage && storage.StorageComponents && storage.StorageComponents.length > 0 && storage.StorageComponents[0].PendingSectors !== null ? storage.StorageComponents[0].PendingSectors || 0 : 0,
        SMART: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].SMART || '' : '',
        SmartScore: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].SmartScore || 0 : 0,
        WipeParams: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].WipeParams || '' : '',
        WipeResult: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].WipeResult || '' : '',
        WipeVerify: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].WipeVerify || '' : '',
        WipeProgress: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].WipeProgress || 0 : 0,
        WipeStarted: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].WipeStarted || null : moment(),
        WipeFinished: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].WipeFinished || null : moment(),
        WipeStatus: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].WipeStatus || 'noterased' : 'noterased',
        WipeMethod: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].WipeMethod === 'ssd' ? 'securaze_ssd_performance' : storage.StorageComponents[0].WipeMethod || 'securaze_ssd_performance' : 'securaze_ssd_performance',
        DataWipeEmployeeID: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].DataWipeEmployeeID || null : null,
        SecurazeSolution: storage && storage.StorageComponents && storage.StorageComponents.length > 0 && storage.StorageComponents[0].SecurazeSolution ? storage.StorageComponents[0].SecurazeSolution : "",
        VerificationResult: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].VerificationResult || '' : '',
        VerificationProgress: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].VerificationProgress || 0 : 0,
        VerificationStarted: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].VerificationStarted || null : moment(),
        VerificationFinished: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].VerificationFinished || null : moment(),
        VerificationStatus: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].VerificationStatus || 'notverified' : 'notverified',
        VerificationMethod: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].VerificationMethod === 'ssd' ? 'securaze_ssd_performance' : storage.StorageComponents[0].VerificationMethod || 'securaze_ssd_performance' : 'securaze_ssd_performance',
        DataVerificationEmployeeID: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].DataVerificationEmployeeID || null : null,
        TransportChannelNumber: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].TransportChannelNumber || null : null,
        BlockSize: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].BlockSize || null : null,
        PhysicalBlockSize: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].PhysicalBlockSize || null : null,
        LogicalBlockSize: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].LogicalBlockSize || null : null,
        TransferMode: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].TransferMode || null : null,
        AMA: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].AMA || null : null,
        SecurityStatus: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].SecurityStatus || null : null,
        EnhancedSecurityErase: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].EnhancedSecurityErase : null,
        FirmwareVersion: storage && storage.FirmwareVersion ? storage.FirmwareVersion : null,
        LifeRemainingPercent: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].LifeRemainingPercent || null : null,
        GrownDefectListCount: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].GrownDefectListCount || null : null,
        PrimaryDefectListCount: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].PrimaryDefectListCount || null : null,
        IsCounterfeit: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].IsCounterfeit ?? null : null,
        CounterfeitReason: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].CounterfeitReason || null : null,
        HeliumLevelPercent: storage && storage.StorageComponents && storage.StorageComponents.length > 0 ? storage.StorageComponents[0].HeliumLevelPercent || null : null,
    };

    let formSettings = {
        Validation: activeStep === 0 ? {
            Type: Yup.string().required('Required'),
            Size: Yup.number().required('Required'),
            Vendor: Yup.string().required('Required'),
            ComponentModel: Yup.string().required('Required'),
            SerialNumber: Yup.string().required('Required'),
            LogicalName: Yup.string().required('Required')
        } :
        activeStep === 1 ? {
            Sectors: Yup.string().required('Required'),
            ReallocatedSectors: Yup.string().required('Required'),
            SmartScore: Yup.number().max(100).min(0),
            LifeRemainingPercent: Yup.number().nullable().max(100).min(0),
            HeliumLevelPercent: Yup.number().nullable().max(100).min(0),
        } : 
        activeStep === 2 ? {
            WipeStatus: Yup.string().required('Required'),
            WipeMethod: Yup.string().when('WipeStatus', {
                is: (val) => val === 'erased',
                then: (schema) => schema.required('Required'),
                otherwise: (schema) => schema.notRequired(),
            }),
            DataWipeEmployeeID: Yup.string().nullable().when('WipeStatus', {
                is: (val) => val === 'erased',
                then: (schema) => schema.required('Required'),
                otherwise: (schema) => schema.notRequired(),
            }),
        } : {
            VerificationStatus: Yup.string().nullable(),
            VerificationMethod: Yup.string().when('VerificationStatus', {
                is: (val) => val === 'verified',
                then: (schema) => schema.required('Required'),
                otherwise: (schema) => schema.notRequired(),
            }),
            DataVerificationEmployeeID: Yup.string().nullable().when('VerificationStatus', {
                is: (val) => val === 'verified',
                then: (schema) => schema.required('Required'),
                otherwise: (schema) => schema.notRequired(),
            }),
        },
        ButtonSubmit: searchParams.editable === '1' && hasPermission(permissions, "component_save") ? {
            Title: translations['save'] || 'SAVE',
            Color: 'primary'
        } : null,
        ButtonCancel: {
            Title: translations['cancel'] || 'CANCEL',
            handleCancel: cancelHandler
        },
        ButtonBack: {
            Title: translations['back'] || 'BACK',
            Color: 'primary',
            handleBack: handleBack
        },
        ButtonNext: {
            Title: translations['next'] || 'NEXT',
            Color: 'primary',
            handleNext: handleNext
        }
    };

    return <Paper className={classes.root}>
        {BackButton(translations)}
        <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data.data}
            PaperProps={{
                classes: {
                    root: classes.submit
                }
            }} >

            <AppLogoLoading />
        </Dialog>
        {!data.data ? <>
            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label, index) => {
                    return (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
            <StorageForm edit={true} methods={data.methods} securazeSolutions={data.securazeSolutions} reportInformation={data.user} loading={creating} handleSubmit={submitHandler} activeStep={activeStep} initialValues={initialValues} translations={translations} formSettings={formSettings} ></StorageForm>
        </>
            : <CircularProgress
                variant="determinate"
                color="primary"
                size={28}
            />}
    </Paper>
}

const mapStateToProps = state => {
    return {
        storage: state.product.storages.loaded ? state.product.storages.loaded : {},
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onEditStorage: storage => dispatch(actions.editStorage(storage)),
        onFetchUsers: (user) => (dispatch(actions.fetchUsers(user))),
        onFetchStorage: storage => dispatch(actions.loadStorage(storage)),
        onFetchErasureMethods: (user) => (dispatch(actions.fetchErasureMethod(user))),
        onFetchSecurazeSolutions: (data) => dispatch(fetchSecurazeSolutions(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(StorageEdit));
